import { defineMessages } from '@cookbook/solid-intl'

export const messages = defineMessages({
    closeButton: {
        defaultMessage: 'Close',
        id: 'ErrorModal.closeButton',
    },
    messageLabel: {
        defaultMessage: 'Message:',
        id: 'ErrorModal.messageLabel',
    },
    stackLabel: {
        defaultMessage: 'Stack:',
        id: 'ErrorModal.stackLabel',
    },
    title: {
        defaultMessage: 'Error occurred',
        id: 'ErrorModal.title',
    },
    unexpectedError: {
        defaultMessage: 'Unexpected Error',
        id: 'ErrorModal.unexpectedError',
    },
})

